// Main application bundle for modern pages
// Includes Flowbite and will include Tabulator and other UI libraries in the future

import 'flowbite';
import './date-utils'; // Import date utilities (exposes functions to global scope)
import './ticket-list-dates'; // Initialize ticket list date displays
import { initToastsFromPage } from './toast';
import { initProfileForm } from './profile-form';
import { initProfileApiTokens } from './profile-api-tokens';
import { initFormSubmitOverlay } from '../components/form-submit-overlay';
import { initShellNavDrawer } from './shell-drawer';
import { initTicketOverviewBulk } from './ticket-overview-bulk';
import { initTicketOverviewToolbarTooltips } from './ticket-overview-toolbar-tooltips';
import { initTicketOverviewMoreFiltersJump } from './ticket-overview-more-filters';
import { initTicketOverviewNavOverlay } from './ticket-overview-nav-overlay';
import { initAdminPrioritiesPage } from './admin-priorities';
import { initPersonForm } from '../components/person-form/person-form';
import { initSearchableComboboxes } from '../components/searchable-combobox/searchable-combobox';
import { initTomcatOverview } from './tomcat-overview';

// Dark mode toggle functionality
document.addEventListener('DOMContentLoaded', () => {
    initToastsFromPage();
    initProfileForm();
    initProfileApiTokens();
    initFormSubmitOverlay();
    initTicketOverviewBulk();
    initTicketOverviewToolbarTooltips();
    initTicketOverviewMoreFiltersJump();
    initTicketOverviewNavOverlay();
    initAdminPrioritiesPage();
    initPersonForm();
    initSearchableComboboxes();
    initTomcatOverview();
    const darkModeToggle = document.getElementById('dark-mode-toggle') as HTMLInputElement;
    const darkModeMenuItem = document.getElementById('dark-mode-menu-item');
    const htmlElement = document.documentElement;
    
    if (!darkModeToggle || !darkModeMenuItem) {
        return;
    }
    
    // Sync checkbox state with current dark mode
    const currentTheme = localStorage.getItem('color-theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (currentTheme === 'dark' || (!currentTheme && prefersDark)) {
        darkModeToggle.checked = true;
    }
    
    // Toggle dark mode when clicking the menu item
    darkModeMenuItem.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Toggle dark mode
        if (htmlElement.classList.contains('dark')) {
            htmlElement.classList.remove('dark');
            localStorage.setItem('color-theme', 'light');
            darkModeToggle.checked = false;
        } else {
            htmlElement.classList.add('dark');
            localStorage.setItem('color-theme', 'dark');
            darkModeToggle.checked = true;
        }
    });
});

// Flowbite registers drawer init on window "load"; sync cookie + margin after that.
window.addEventListener('load', () => {
    initShellNavDrawer();
});
